import React from 'react';
import { useLiveApp } from '../../context/LiveAppContext';

export function LiveStatusBar() {
 const { 
  isOnline, 
  isSaving, 
  lastSaved, 
  error, 
  authState,
  logout,
  resetCloudData
 } = useLiveApp();

 const formatLastSaved = (date: Date | null) => {
  if (!date) return 'Never';
  
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);
  
  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffMins < 1440) return `${Math.floor(diffMins / 60)}h ago`;
  return date.toLocaleDateString();
 };

 if (!authState.isAuthenticated) return null;

 return (
  <div className="bg-white border-b border-gray-200 px-4 py-2">
   <div className="flex items-center justify-between">
    <div className="flex items-center space-x-4 text-sm">
     {/* Online Status */}
     <div className="flex items-center space-x-2">
      <div className={`w-2 h-2 rounded-full ${isOnline ? 'bg-green-500' : 'bg-red-500'}`} />
      <span className={isOnline ? 'text-green-700' : 'text-red-700'}>
       {isOnline ? 'Online' : 'Offline'}
      </span>
     </div>

     {/* Save Status */}
     <div className="flex items-center space-x-2">
      {isSaving ? (
       <>
        <div className="animate-spin h-3 w-3 border-2 border-blue-500 border-t-transparent rounded-full" />
        <span className="text-blue-700">Saving...</span>
       </>
      ) : (
       <>
        <span className="text-gray-500">Last saved:</span>
        <span className="text-gray-700 font-medium">
         {formatLastSaved(lastSaved)}
        </span>
       </>
      )}
     </div>

     {/* Error Status */}
     {error && (
      <div className="flex items-center space-x-2 text-red-600">
       <span className="w-2 h-2 rounded-full bg-red-500" />
       <span>{error}</span>
      </div>
     )}
    </div>

    {/* User Info and Actions */}
    <div className="flex items-center space-x-4">
     <span className="text-sm text-gray-600">
       {authState.user?.name}
     </span>
     
     <button
      onClick={resetCloudData}
      className="text-xs bg-red-100 text-red-700 px-2 py-1 rounded hover:bg-red-200 transition-colors"
     >
      Reset Cloud
     </button>

     <button
      onClick={logout}
      className="text-sm text-gray-500 hover:text-gray-700"
     >
      Sign Out
     </button>
    </div>
   </div>

   {/* Auto-save Notice */}
   <div className="mt-1">
    <span className="text-xs text-gray-500">
      Changes auto-save every 2 seconds • Real-time collaboration enabled
    </span>
   </div>
  </div>
 );
}